var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#90A9C0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "star_body",
    opacity: 0.142,
    d: "m10.706 13-.164-.972-.512-2.994 2.242-2.138.728-.694-1.013-.147-3.114-.459L7.46 2.884 7 2l-.46.884-1.413 2.712-3.114.459L1 6.202l.728.694L3.97 9.034l-.512 2.994-.164.972.908-.451L7 11.152l2.798 1.397.908.451z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star_stroke",
    d: "m12.133 14-.205-1.237-.64-3.811 2.801-2.72.911-.884-1.266-.187-3.892-.584-1.767-3.452L7.5 0l-.575 1.125-1.767 3.452-3.892.584L0 5.348l.91.884 2.802 2.72-.64 3.81L2.867 14l1.136-.575L7.5 11.648l3.497 1.777 1.136.575Zm-1.681-2.269-2.657-1.355-.295-.147-.295.147-2.657 1.355.485-2.902.055-.319-.235-.23-2.131-2.063 2.957-.442.33-.05.15-.289L7.5 2.814l1.34 2.622.151.29.33.049 2.957.442-2.131 2.062-.235.231.055.32.485 2.901Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.266613c8e2fd6a1652719feb5b8e074c.svg";
export { ForwardRef as ReactComponent };